export default {
  users: [],
  invites: [],
  publishers: {},
  buyers: {},
  error: {},
  columns: [],
  userVisibleColumns: {},
  status: {}
};